import {clearString, FullAlphabet, missingCharKeydAlphabet, removeDiacritics} from "../helpers/stringHelpers";


const cachedChinase = {};
const SEPARATOR = ''
const Chinase = {
    table: function (missing,key) {
        let mergedMissing = missing.join('') + key;
        if (cachedChinase[mergedMissing]) {
            return cachedChinase[mergedMissing]
        }
        // let myAlphabet = FullAlphabet.filter((str) => {
        //     return str !== missing[0].toLowerCase().replace('ch', '*') &&
        //         str !== missing[1].toLowerCase().replace('ch', '*')
        // })
        let myAlphabet = missingCharKeydAlphabet(key,missing);
        console.log([...myAlphabet].splice(0,5) .join(', '))
        console.log([...myAlphabet].splice(5,5) .join(', '))
        console.log([...myAlphabet].splice(10,5).join(', '))
        console.log([...myAlphabet].splice(15,5).join(', '))
        console.log([...myAlphabet].splice(20,5).join(', '))
        cachedChinase[mergedMissing] = myAlphabet;
        return myAlphabet;
    }


}

export const methods = {
    cypher: function (input, hasCh=false, missing = ['ch', 'q'], params) {
        let key = (params[1]||"").replaceAll(/[^a-zA-Z]/gm, '');
        let cyphered = []
        let cleaned = removeDiacritics(input).toLowerCase();
        if(missing.includes('ch')){
            cleaned.replaceAll('ch','*')
        }
        cleaned.split('').forEach((char)=>{
           let index = Chinase.table(missing,key).indexOf(char)
            cyphered.push([Math.floor(index / 5)+1,(index % 5)+1])
        })
        // console.log(cyphered);
        return cyphered;
    },
    decypher: function (input, hasCh=false, missing = ['ch', 'q'], params) {
        return input;
    },
};

export default {...methods,SEPARATOR}